module.exports = __webpack_public_path__ + "img/ico-passive-media.d9ce36bc.svg";